<div
  class="app-nav-item"
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()">
  <ng-content select="[trigger]"></ng-content>
  <div class="app-nav-menu-panel" role="menu" *ngIf="isOpen">
    <ng-content select="[content]"></ng-content>
  </div>
</div>
